import React from 'react';
import { Modal, Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { DESIGN_AREA_SETTINGS_TAB } from '../../../SidebarMenu/translationValues';
import styled from 'styled-components';

const NAMESPACES = ['DESIGN_AREA_SETTINGS_TAB'];

const ModalContent = styled.div`
  padding: 20px 0;
  color: #333;
  line-height: 1.6;
`;

const ModalMessage = styled.div`
  margin-bottom: 16px;
  font-size: 14px;
`;

const BusinessContractConfirmationModal = ({ visible, onConfirm, onCancel, loading }) => {
  const { t } = useTranslation(NAMESPACES);

  return (
    <Modal
      title={t(
        DESIGN_AREA_SETTINGS_TAB.BUSINESS_CONTRACT_CONFIRM_TITLE?.key || 'Confirm Business Contract Change',
        DESIGN_AREA_SETTINGS_TAB.BUSINESS_CONTRACT_CONFIRM_TITLE?.value || 'Confirm Business Contract Change'
      )}
      visible={visible}
      onCancel={onCancel}
      maskClosable={false}
      width={500}
      footer={[
        <Button key="cancel" onClick={onCancel} disabled={loading}>
          {t(
            DESIGN_AREA_SETTINGS_TAB.BUSINESS_CONTRACT_CANCEL_BUTTON?.key || 'Cancel',
            DESIGN_AREA_SETTINGS_TAB.BUSINESS_CONTRACT_CANCEL_BUTTON?.value || 'Cancel'
          )}
        </Button>,
        <Button key="confirm" type="primary" onClick={onConfirm} loading={loading}>
          {t(
            DESIGN_AREA_SETTINGS_TAB.BUSINESS_CONTRACT_CONFIRM_BUTTON?.key || 'Confirm',
            DESIGN_AREA_SETTINGS_TAB.BUSINESS_CONTRACT_CONFIRM_BUTTON?.value || 'Confirm'
          )}
        </Button>,
      ]}
      style={{ top: 200 }}
    >
      <ModalContent>
        <ModalMessage>
          {t(
            DESIGN_AREA_SETTINGS_TAB.BUSINESS_CONTRACT_CONFIRM_MESSAGE?.key || 
            'Enabling business contract data mapping will affect transactions currently in progress. Any PDFs being generated may use the new data transformation rules. Are you sure you want to proceed?',
            DESIGN_AREA_SETTINGS_TAB.BUSINESS_CONTRACT_CONFIRM_MESSAGE?.value || 
            'Enabling business contract data mapping will affect transactions currently in progress. Any PDFs being generated may use the new data transformation rules. Are you sure you want to proceed?'
          )}
        </ModalMessage>
      </ModalContent>
    </Modal>
  );
};

export default BusinessContractConfirmationModal;


